import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/vlogo.png";
import navIcon1 from "../assets/img/twitter.svg";
import navIcon2 from "../assets/img/discord.svg";
import navIcon3 from "../assets/img/instagram.svg";
import navIcon4 from "../assets/img/telegram.svg";
import dlogo from "../assets/img/dlogo.png";

import "../App.css";

export default function Footer() {
  return (
    <footer className="footer" id="footer">
      <Container>
        <Row className="align-items-center ">
          <Col size={12} sm={6} className="text-center text-sm-start">
            <div className="social-icon">
              <img src={logo} alt="Logo" />
            </div>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end mt-3">
            <div className="social-icon">
              <a
                href="https://twitter.com/VickyGaming_coc?t=_-JvKViwcEqqXGCEIGT7Lg&s=08"
                target="_blank"
                rel="noreferrer"
              >
                <img src={navIcon1} alt="Icon" style={{ color: "#fff" }} />
              </a>

              <a
                href="https://discord.gg/n7HHREYGE4"
                target="_blank"
                rel="noreferrer"
              >
                <img src={navIcon2} alt="Icon" />
              </a>
              <a
                href="https://www.instagram.com/vicky_gaming_coc/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={navIcon3} alt="Icon" />
              </a>
              <a
                href="https://telegram.me/+XkIDLFf3XDOLekyR"
                target="_blank"
                rel="noreferrer"
              >
                <img src={navIcon4} alt="Icon" />
              </a>
            </div>
            <p>
              <span>&copy; 2023.</span>
              <span>Designed By</span>
              <img
                src={dlogo}
                alt=""
                style={{
                  width: "30px",
                  height: "22px",
                  paddingLeft: "8px",
                  marginTop: "-6px",
                }}
              />{" "}
              <span style={{ paddingLeft: "3px" }}>
                &#174; All Rights Reserved
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
